import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import Text from '@/components/basic/text';
import theme from '@/style';
import React from 'react';
import {StyleProp, StyleSheet, ViewStyle} from 'react-native';
export interface BetsButtonProps {
  title?: string;
  disabled?: boolean;
  onPress?: () => void;
  style?: StyleProp<ViewStyle>;
}

const BetsButton = ({
  title = '',
  style = {},
  disabled = false,
  onPress = () => {},
}: BetsButtonProps) => {
  return (
    <NativeTouchableOpacity
      onPress={onPress}
      disabled={disabled}
      style={[
        theme.background.primary,
        theme.flex.center,
        styles.button,
        // eslint-disable-next-line react-native/no-inline-styles
        {opacity: disabled ? 0.5 : 1},
        style,
      ]}>
      <Text
        color={theme.basicColor.white}
        fontFamily="fontInterBold"
        fontSize={14}>
        {title}
      </Text>
    </NativeTouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    width: 52,
    height: 32,
    borderRadius: 4,
    elevation: 3,
    shadowColor: '#00000040',
    shadowOffset: {width: 0, height: 1},
    shadowOpacity: 0.2,
    shadowRadius: 4,
    paddingHorizontal: 0,
  },
});

export default BetsButton;
